<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-08-13 15:44:49
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Roster\RosterRecord\RosterRecord.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-07-22 17:40:26
-->
<template>
  <!--startprint-->
  <div>
    <ContentLayout
      ref="print"
      :title="$t('label_essweb_admin_RosterRecord_list_title')"
      pad="0"
      filterable
      backgroundClass="transparent"
      widthClass="min-1200"
      @filter="
        (val) => {
          filterPageData = val;
        }
      "
    >
      <!-- 筛选 -->
      <template v-slot:top-selection="{ filter }">
        <v-container fluid class="d-flex pa-0 ma-0 justify-space-around">
          <v-sheet
            class="d-flex flex-row justify-end transparent"
            v-if="!isEdited"
          >
            <!-- 重新计算考勤被移动到考勤记录里 -->
            <v-btn
              text
              v-if="false"
              color="primary"
              class="text-capitalize ml-n6"
              depressed
              @click="
                toDo = 'recalculate';
                showRecalcul = true;
              "
              rounded
              >{{
                $t("label_essweb_RosterRecord_list_recalulateBtnLabel")
              }}</v-btn
            >
            <v-btn
              text
              :ripple="false"
              color="primary  "
              class="text-capitalize ml-n3"
              depressed
              v-if="hasBtn('admin-roster-schedule-initialize')"
              @click="
                toDo = 'regenerate';
                showRecalcul = true;
              "
              rounded
              >{{
                $t("label_essweb_RosterRecord_list_regenerateBtnLabel")
              }}</v-btn
            >
          </v-sheet>
          <v-spacer></v-spacer>
          <Selections2
            :objects="filterObjects"
            small-chip
            @filter="
              filter();
              toFilter(filter);
            "
            @update="
              (prop, value, selected) => {
                if (prop == 'department') curDept = value; //触发岗位更新下拉
                $fliterValue(filterObjects, prop, value, selected);
              }
            "
            @reset="
              (apply) => {
                $fliterValue(filterObjects, null, null);
                if (apply) {
                  filter();
                  toFilter(filter);
                }
              }
            "
          />
        </v-container>
      </template>
      <!-- nav-actions -->
      <template v-slot:nav-actions>
        <!-- <v-btn @click="toPrint">print</v-btn> -->
        <!-- <v-btn
          icon
          class="primary mr-4"
          color="white"
          width="40"
          height="40"
          @click="showPrint = true"
        >
          <span class="material-icons-round">print</span>
        </v-btn> -->
        <v-btn
          icon
          class="primary mr-4"
          color="white"
          width="40"
          v-if="hasBtn('export-admin-roster-schedule')"
          height="40"
          v-show="!isEdited"
          @click="
            $confirmWarn(
              $t('label_essweb_RosterRecord_list_exportOutBtnLabel'),
              $t('message_essweb_system_operation_export_outLabel'),
              null,
              $t('message_essweb_system_operation_export_exportOutLabel')
            ).then((res) => {
              if (res) showExportOut = true;
            })
          "
        >
          <!-- julia bug1038 -->
          <svg-icon size="24" iconClass="export" />
          <!-- {{ $t("label_essweb_RosterRecord_list_exportOutBtnLabel") }} -->
        </v-btn>
        <v-btn
          icon
          class="primary mr-4"
          color="white"
          v-if="hasBtn('import-admin-roster-schedule')"
          width="40"
          height="40"
          v-show="!isEdited"
          @click="showExportIn = !showExportIn"
        >
          <!-- julia bug1038 -->
          <svg-icon size="24" iconClass="import" />
          <!-- {{ $t("label_essweb_RosterRecord_list_exportInBtnLabel") }} -->
        </v-btn>
        <!-- 2021-06-04 修改直接生成排版 brain lsj-->
        <v-btn
          icon
          class="primary mr-4"
          color="white"
          width="40"
          v-if="hasBtn('admin-roster-schedule-generate-roster-form')"
          height="40"
          v-show="!isEdited"
          @click="showRosterForm = true"
        >
          <!-- julia bug1038 -->
          <svg-icon size="24" iconClass="calendar_roster" />
          <!-- {{ $t("label_essweb_RosterRecord_list_generalRosterBtnLabel") }} -->
        </v-btn>
        <!-- 废弃 2021-06-04 修改直接生成排版 brain lsj   -->
        <v-menu
          bottom
          v-if="0"
          v-model="showMenu"
          offset-y
          :close-on-content-click="false"
          nudge-left="250"
          nudge-top="-6"
          origin="top right"
          class="rounded-lg"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="primary"
              rounded
              v-show="!isEdited"
              class="text-capitalize mr-4"
              v-bind="attrs"
              v-on="on"
              >{{
                $t("label_essweb_RosterRecord_list_generalRosterBtnLabel")
              }}</v-btn
            >
          </template>
          <v-card class="pa-0 ma-0" width="400">
            <v-card-text class="pa-0 ma-0">
              <v-form ref="form" lazy-validation>
                <v-row justify="center" align="center" class="pa-3 pb-0">
                  <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="py-0">
                    <DateTimePicker
                      type="daterange"
                      isRequire
                      :canDelete="false"
                      :value="dateTerminal"
                      :defaultStartTime="defaultStartDate"
                      :defaultEndTime="defaultEndDate"
                      :placeholder="
                        $t('label_essweb_RosterRecord_list_seTimeLabel')
                      "
                      @change="
                        (time, isre) => {
                          dateTerminal = time;
                          if (isre) {
                            defaultStartDate = time ? time.split(' - ')[0] : '';
                            defaultEndDate = time ? time.split(' - ')[1] : '';
                          }
                        }
                      "
                    />
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
            <CardActions
              okBtn
              @cancel="
                showMenu = false;
                reviewDateTerminal();
              "
              @ok="setDateTerminal()"
            />
          </v-card>
        </v-menu>
      </template>
      <!-- nav-actions -->
      <!-- content -->
      <template v-slot:page-main>
        <v-app-bar class="mrc-grey pa-0" v-if="false" elevation="0" dense>
          <v-sheet
            class="d-flex flex-row justify-end transparent"
            v-if="!isEdited"
          >
            <!-- 重新计算考勤被移动到考勤记录里 -->
            <v-btn
              text
              v-if="false"
              color="primary"
              class="text-capitalize ml-n6"
              depressed
              @click="
                toDo = 'recalculate';
                showRecalcul = true;
              "
              rounded
              >{{
                $t("label_essweb_RosterRecord_list_recalulateBtnLabel")
              }}</v-btn
            >
            <v-btn
              text
              :ripple="false"
              color="primary  "
              class="text-capitalize ml-n3"
              depressed
              @click="
                toDo = 'regenerate';
                showRecalcul = true;
              "
              rounded
              >{{
                $t("label_essweb_RosterRecord_list_regenerateBtnLabel")
              }}</v-btn
            >
          </v-sheet>
          <v-spacer></v-spacer>

          <v-sheet v-if="isEdited" width="400" color="transparent">
            <DateTimePicker
              type="daterange"
              isRequire
              :canDelete="false"
              appendIcon="event"
              :disable="true"
              :value="dateTerminal"
              :defaultStartTime="defaultStartDate"
              :defaultEndTime="defaultEndDate"
              :placeholder="$t('label_essweb_RosterRecord_list_seTimeLabel')"
              @change="
                (time, isre) => {
                  dateTerminal = time;
                  if (isre) {
                    defaultStartDate = time ? time.split(' - ')[0] : '';
                    defaultEndDate = time ? time.split(' - ')[1] : '';
                  }
                }
              "
            />
          </v-sheet>
        </v-app-bar>
        <RosterPlan
          ref="printarea2"
          :cycleType="cycleType"
          :showExportIn="showExportIn"
          @closeExportIn="showExportIn = false"
          @closeCalcul="showRecalcul = false"
          :toDo="toDo"
          @back="
            isEdited = false;
            dateTerminal = '';
          "
          @reset="
            (e) => {
              if (e) $fliterValue(filterObjects, null, null);
            }
          "
          :hasPermission="hasBtn('edit-admin-roster-schedule')"
          :showRosterForm="showRosterForm"
          @closeRosterForm="showRosterForm = false"
          :showRecalcul="showRecalcul"
          :startTime="startTime"
          :isEdited="isEdited"
          :filter-data="filterData"
          :selectStartDate="startDate"
          :selectEndDate="endDate"
          :endTime="endTime"
          @onTrigerPage="
            (logic, time) => {
              toResetTime(logic, time);
            }
          "
          @check="
            (staffs) => {
              selectStaffs = staffs;
            }
          "
        />
      </template>
      <!-- tools -->
      <template v-slot:tools-main>
        <ExportOut
          :show="showExportOut"
          @export="exportOut"
          @close="showExportOut = false"
        />
      </template>
      <!-- actions -->
      <template v-slot:page-actions>
        <CardActions
          :step="step == curStep ? false : true"
          @next="toNext"
          v-if="isEdited"
          :preStep="curStep > 1 ? true : false"
          @pre="curStep = curStep - 1"
          @cancel="
            isEdited = false;
            dateTerminal = '';
          "
        />
      </template>
    </ContentLayout>
    <!--endprint-->
  </div>
</template>
<script>
import dayjs from "dayjs";
import RosterPlan from "@/Page/EssAdmin/Roster/RosterRecord/components/RosterPlan";
import ExportOut from "@/Page/EssAdmin/Roster/RosterRecord/components/ExportOut";
import { mapGetters } from "vuex";
export default {
  name: "RosterRecord",
  components: { RosterPlan, ExportOut },
  computed: {
    ...mapGetters(["userToken"]),
  },
  data() {
    return {
      cycleType: 14,
      step: 2,
      showExportIn: false,
      showExportOut: false,
      showRosterForm: false,
      showPrint: false,
      showRecalcul: false,
      curStep: 1,
      toDo: "",
      isEdited: false,
      startTime: "2020-07-09",
      endTime: "2020-09-09",
      showMenu: false,
      selectStaffs: [],
      dateTerminal: "",
      saveStartDate: "",
      saveEndDate: "",
      defaultStartDate: "",
      defaultEndDate: "",
      startDate: "",
      endDate: "",
      filterPageData: null,
      curDept: [],
      filterData: null,
      filterObjects: [
        {
          type: "select",
          sequence: 0,
          showKey: "preferred_name",
          subKey: "job_post_name",
          position: "right",
          name: "staff",
          multiple: true,
          avatar: true,
          twoLine: true,
          label: "label_essweb_RosterRecord_dialog_staffLabel",
          value: [],

          selected: [],
          data: {
            api: "/staff/get-staff-list/",
            url_type: "all_staff",
            args: null,
            table: "mrbase_sys_staffs",
            type: "",
            modelKey: "staff_code",
            valueKey: "staff_id",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 1,
          position: "right",
          showKey: "org_level_name",
          name: "department",
          multiple: true,
          label: "label_essweb_UM_filters_departmentLabel",
          value: [],

          selected: [],
          data: {
            api: "/dept/get-tree/",
            url_type: "tree",
            args: null,
            table: "mrbase_sys_org_levels",
            type: "",
            modelKey: "org_level_name",
            valueKey: "uuid",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 2,
          position: "right",
          showKey: "job_post_name",
          name: "job",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobLabel",
          value: [],

          selected: [],
          data: {
            api: "/job-post/get-list/",
            url_type: "primary",
            args: { dept_uuid: "" },
            table: "mrbase_sys_job_posts",
            type: "",
            modelKey: "job_post_name",
            valueKey: "uuid",
            global: false,
          },
        },
        {
          type: "select",
          sequence: 3,
          position: "right",
          showKey: "dict_label",
          name: "staff_status",
          disabled: false,
          multiple: true,
          label: "label_essweb_UM_filters_jobStatusLabel",
          value: [],
          selected: [],
          data: {
            api: "/dictionary/list-dictionary-byname/",
            url_type: "primary",
            args: { dict_name: "staffStatus" },
            table: "mrbase_sys_dict",
            type: "lang",
            modelKey: "dict_label",
            valueKey: "dict_value",
            global: false,
          },
        },
      ],
    };
  },
  watch: {
    isEdited() {
      this.selectStaffs = [];
    },
    startDate(val) {
      if (val) {
        this.startTime = val;
        this.endTime = dayjs(val)
          .add(this.cycleType - 1, "day")
          .format("YYYY-MM-DD");
      }
    },
    dateTerminal(val) {
      if (!val.value) {
        this.startDate = "";
        this.endDate = "";
        this.saveStartDate = this.startDate;
        this.saveEndDate = this.endDate;
        this.defaultStartDate = this.startDate;
        this.defaultEndDate = this.endDate;
      }
    },
    showPrint(val) {
      if (val) {
        this.$toPage(
          "/roster-print/" +
            this.$aesEncrypt(
              JSON.stringify({
                token: this.userToken,
                start_date: "2021-07-01",
                end_date: "2021-09-08",
              })
            )
        );
      }
    },
    curDept(val) {
      //监听部门变化
      this.$fliterValue(this.filterObjects, "job", []);
      if (!val || val.length == 0) {
        this.filterObjects[2]["disabled"] = true;
      }
      if (val) {
        let arr = [];
        if (val.length) {
          this.filterObjects[2]["disabled"] = false;
          val.map((e) => {
            if (e && e.uuid) arr.push(e.uuid);
          });
          this.filterObjects[2]["data"]["args"]["dept_uuid"] = arr.join(",");
        } else {
          return;
        }
      }
    },
  },
  mounted() {
    this.getBtnPermissionList();
    this.startTime = this.resettingTime()[0];
    this.endTime = this.resettingTime()[1];
    // console.log(this.endTime);
    // console.log(this.startTime);
    // console.log(dayjs().subtract(this.cycleType, "day").format("YYYY-MM-DD"));
  },
  methods: {
    toPrint() {
      var bdhtml = this.$refs.printarea2;
      this.$print(this.$refs.print);
    },
    exportOut(staff, start, end) {
      let data = {
        staff_uuid: staff.join(","),
        start_time: this.$getTimeValue(start),
        end_time: this.$getTimeValue(end),
      };
      this.showExportOut = false;
      this.$Request({
        method: "POST",
        table: "ess_att_roster",
        url: "/roster/export/",
        data: data,
        type: "export",
        export_title: this.$t("label_essweb_RosterRecord_export_title", {
          start: start,
          end: end,
        }),
      });
    },
    toFilter(callback, page, perpage) {
      const that = this;
      let object = [];
      object = this.filterObjects.filter((ele) =>
        Object.prototype.toString.call(ele["value"]).toLowerCase() ===
        "[object array]"
          ? ele["value"].length
          : ele.value !== undefined && ele.value != ""
      );
      let data = {
        //
        // start_date: this.$getTimeValue(this.startTime),
        // end_date: this.$getTimeValue(this.endTime),
        // type: 2,
      };
      object.map((item) => {
        if (item["name"] == "staff")
          data["staff_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "staff_status")
          data["staff_status"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "job")
          data["job_post_uuid"] = item.value ? item.value.join(",") : "";
        if (item["name"] == "department") {
          let arr = [];
          if (item.value.length) {
            item.value.map((e) => {
              e && e.uuid ? arr.push(e.uuid) : null;
            });
          }
          data["dept_uuid"] = arr.join(",");
        }
      });

      this.filterData = data;
    },
    setDateTerminal: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      } else {
        this.showMenu = false;
        this.isEdited = true;
        this.startDate = this.dateTerminal
          ? this.dateTerminal.split(" - ")[0]
          : "";
        this.endDate = this.dateTerminal
          ? this.dateTerminal.split(" - ")[1]
          : "";
        this.saveStartDate = this.startDate;
        this.saveEndDate = this.endDate;
        this.defaultStartDate = this.startDate;
        this.defaultEndDate = this.endDate;
      }
    },
    reviewDateTerminal: function () {
      this.startDate = this.saveStartDate;
      this.endDate = this.saveEndDate;
      this.defaultStartDate = this.saveStartDate;
      this.defaultEndDate = this.saveEndDate;
      this.dateTerminal = this.saveStartDate
        ? this.saveStartDate + " - " + this.saveEndDate
        : "";
    },
    //  重设时间
    resettingTime: function (start, logic = "add") {
      let end = "";
      if (!start) {
        start = dayjs().format("YYYY-MM-DD");
        if (logic == "add") {
          end = dayjs()
            .add(this.cycleType - 1, "day")
            .format("YYYY-MM-DD");
          return [start, end];
        }
        if (logic == "red") {
          end = dayjs().subtract(this.cycleType, "day").format("YYYY-MM-DD");
          return [end, start];
        }
      } else {
        start = dayjs(start).format("YYYY-MM-DD");
        if (logic == "add") {
          end = dayjs(start)
            .add(this.cycleType - 1, "day")
            .format("YYYY-MM-DD");
          return [start, end];
        }
        if (logic == "red") {
          end = dayjs(start)
            .subtract(this.cycleType, "day")
            .format("YYYY-MM-DD");
          return [end, start];
        }
      }
    },
    toResetTime: function (logic, time) {
      let start = this.startTime;
      let end = this.endTime;
      if (!logic) {
        this.startTime = this.resettingTime()[0];
        this.endTime = this.resettingTime()[1];
      } else {
        if (logic == "add") {
          if (time) {
            this.startTime = this.resettingTime(time, "add")[0];
            this.endTime = this.resettingTime(time, "add")[1];
          } else {
            this.startTime = this.resettingTime(end, "add")[0];
            this.endTime = this.resettingTime(end, "add")[1];
          }
        } else {
          this.startTime = this.resettingTime(start, "red")[0];
          this.endTime = this.resettingTime(start, "red")[1];
        }
      }
    },
    toNext: function () {
      if (this.selectStaffs.length <= 0) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_selectAgain"),
          text: this.$t(
            "message_essweb_rosterFormRecord_form_selectStaffLabel"
          ),
          type: "warning",
        });
        return false;
      }
      this.showRosterForm = true;
    },
  },
};
</script>
